import type { Colors } from '@nick-mazuk/ui/elements/button'
import { Button } from '@nick-mazuk/ui/elements/button'
import { Download } from '@nick-mazuk/ui/elements/icon'
import { Image } from '@nick-mazuk/ui/elements/image'
import { TextContent } from '@nick-mazuk/ui/elements/text-content'
import { YouTube } from '@nick-mazuk/ui/elements/video'
import BlockContent from '@sanity/block-content-to-react'
import type { SanityImageSource } from '@sanity/image-url/lib/types/types'

import type { Script } from 'lib/sanity'
import { imageBuilder } from 'lib/sanity'

type ScriptItemData = {
    script: Script
    color?: Colors
}
const buildImage = (imageRef: SanityImageSource): string => {
    if (imageRef) return `${imageBuilder.image(imageRef)}`
    return ''
}

export const ScriptItem = ({ script, color = 'primary' }: ScriptItemData): JSX.Element => {
    return (
        <div id={script.title}>
            <TextContent fullwidth responsive>
                <h3>{script.title}</h3>
                <BlockContent blocks={script.description} />
                {script.video && <YouTube id={script.video} title={script.title} />}
                {script.image && !script.video && (
                    <Image src={buildImage(script.image)} alt={script.title} />
                )}
            </TextContent>
            <div className='mt-8'>
                <Button value='Download' color={color} icon={<Download />} href={script.file} />
            </div>
        </div>
    )
}

export type ScriptItem = ReturnType<typeof ScriptItem>
